import { Component, OnInit } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import { Helper } from '../../helper';
import { Constants } from '../../constants';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  service: string;
  currentBooking: any;
  currentClinic = '';
  selectedClinic: any;
  clinicServices = [];
  bodyParts = [];
  profileLink: string;
  token: string;
  bookings = false;
  flowType: string;
  superClinicId: string;
  preselectedClinic: string;
  preService: string;
  singleClinic: string;
  bookingText = 'BOOK ET ANDET SUNDHEDSTILBUD';
  currentUser: any = this.helper.getStorage("currentUser");
  allClinics: Array<any> = this.helper.getStorage("allClinics");
  allBookings: Array<any> = this.helper.getStorage("bookings");
  readonly bodyPartLabels: any = Constants.BODY_PARTS_LABELS;
  readonly flowName: any = Constants.FLOW_TYPE;

  constructor(private route: ActivatedRoute, 
              private router: Router,
              public helper: Helper) {}

  ngOnInit() {
    let bookingsCount;
    const self = this;
    if (this.allBookings) {
      bookingsCount = this.allBookings.length;

      if (bookingsCount > 0) {
        this.bookings = true;
      }
    }

    this.route.queryParams.subscribe((params: Params) => {
      this.flowType = params.type;
      this.superClinicId = params.superClinicId;
      this.preService = params.service;
      this.singleClinic = params.singleClinic;
      
      if (params.bookingToken) {
        this.token = params.bookingToken;
        this.profileLink = '/profile?token=' + this.token;
      } else {
        this.profileLink = '/profile';
      }

      if (params.type === self.flowName.aalborg) {
        this.bookingText = 'BOOK TID';
      }

      if (params.clinics) {
        this.preselectedClinic = params.clinics.toString();
      }
    });

    this.repeatBooking(bookingsCount);
  }

  repeatBooking(bookingsCount) {
    
    if (
      bookingsCount > 0 &&
      this.allBookings[bookingsCount - 1].therapistData
    ) {
      this.service = 'offered';
      this.currentClinic = this.allClinics.filter(
        (el) => el.id == this.currentUser.data.clinicId
      )[0].name;

      if (this.preselectedClinic) {
        const preselectedBookings = this.allBookings.filter(booking => booking.clinic === this.preselectedClinic);

        this.currentBooking = preselectedBookings[preselectedBookings.length - 1];
      } else {
        this.currentBooking = this.allBookings[bookingsCount - 1];
      }
    } else {
      this.service = '';
    }
  }

  showServices() {
    this.bookings = false;
  }

  setupUrl(url) {
    const params = {
      type: this.flowType,
      service: this.preService,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.preselectedClinic;
    }

    // if fysiq flow, don't send service
    if (url === '/offer-fysiq') {
      if (this.flowType === this.flowName.aalborg) {
        params['service'] = this.preService;
        url = '/find-clinic';
      }
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate([url], navigationExtras);
  }

  bookOfferedVisit(offeredBooking: any) {
    this.prepareBookingRepeat(offeredBooking);

    if (offeredBooking.serviceData.service_type === "KX") {
      localStorage.setItem(
        'expertTherapist',
        JSON.stringify([offeredBooking.therapistData])
      );
    }
    
    const params = {
      preselected_therapist: 'true',
      clinics: this.currentBooking.therapistData.clinic_id,
      isExpert: offeredBooking.serviceData.service_type === "KX" ? true : false,
      type: this.flowType,
      singleClinic: this.singleClinic,
      service:
        this.flowType === this.flowName.aalborg
          ? 'FY'
          : this.currentBooking.comment.treatment,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    const navigationExtras: NavigationExtras = { queryParams: params };

    if (this.flowType === this.flowName.aalborg) {
      this.router.navigate(['/booking-visit'], navigationExtras);
    } else {
      this.router.navigate(['/service'], navigationExtras);
    }
  }

  prepareBookingRepeat(offeredBooking) {
    if (offeredBooking.comment.bodyparts.indexOf(',') > -1) {
      const joinedParts = offeredBooking.comment.bodyparts.split(',');

      joinedParts.map((part) => {
        part = part.replace(/\s/g, '');
      });
    }

    localStorage.setItem(
      'selectedService',
      JSON.stringify(offeredBooking.comment.behandling)
    );
    localStorage.setItem(
      'clinicTherapists',
      JSON.stringify([offeredBooking.therapist.toLowerCase()])
    );
    localStorage.setItem(
      'bodyParts',
      JSON.stringify(
        offeredBooking.comment.bodyparts
          ? offeredBooking.comment.bodyparts.split(',')
          : null
      )
    );
  }

  toProfile() {
    this.setupUrl('/' + this.profileLink);
  }

  myBookings() {
    this.setupUrl('/bookings');
  }

  bookNew() {
    this.setupUrl('/find-clinic');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/welcome/welcome.component.ts